import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../lib/utils.js';

export type SearchTokenStatus = 'open' | 'locked';

export interface SearchTokenProps extends HTMLAttributes<HTMLSpanElement> {
  /** Axis label shown before the value, e.g. "Categoria". */
  prefix: string;
  /** Locked value; omit while status is `open`. */
  value?: string;
  status?: SearchTokenStatus;
  children?: ReactNode;
}

/** Facet chip **inside** a search field. Not a toolbar `Tag`. */
export function SearchToken({
  className,
  prefix,
  value,
  status = 'locked',
  children,
  ...props
}: SearchTokenProps) {
  return (
    <span
      className={cn('search-token', status === 'open' && 'search-token--open', className)}
      data-status={status}
      {...props}
    >
      <span className="search-token__prefix">{prefix}:</span>
      {value !== undefined && value !== '' ? (
        <span className="search-token__value">{value}</span>
      ) : null}
      {children}
    </span>
  );
}

export interface SearchTokenCloseProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
}

export function SearchTokenClose({
  className,
  label = 'Remover facet',
  children,
  ...props
}: SearchTokenCloseProps) {
  return (
    <button
      type="button"
      className={cn('search-token__close', className)}
      aria-label={label}
      {...props}
    >
      {children ?? '×'}
    </button>
  );
}
